module.exports = __webpack_public_path__ + "img/1.ca1519d6.png";